import {Component, Input} from '@angular/core';

@Component({
  selector: 'app-homestead-svg',
  imports: [],
  templateUrl: './homestead-svg.component.html',
  styleUrl: './homestead-svg.component.css'
})
export class HomesteadSvgComponent {
  
  @Input() width: string = '50'
  @Input() height: string = '50'
  @Input() colored: boolean = false
}
